import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import React from 'react'
import { INDUSTRIES, OCCUPATIONS } from '../../formAssets'

interface TrainingHoursProps extends WithStyles<typeof styles> {
	required?: boolean
	handleOccupationChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleIndustryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	jobPlacementIndustry: string
	jobPlacementOccupation: string
}

const TrainingHours: React.FC<TrainingHoursProps> = (props: TrainingHoursProps) => {
	const {
		classes,
		handleIndustryChange,
		handleOccupationChange,
		jobPlacementIndustry,
		jobPlacementOccupation,
		required,
	} = props

	return (
		<div data-auto="role-section">
			<Grid container={true} spacing={8}>
				<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
					Role&#58;{ props.required === true && (<span className={classes.requiredField} >*</span> ) }
				</Grid>
				<Grid item={true} xs={12} sm={5}>
					<TextField
						name="jobPlacementOccupation"
						select={true}
						required={required}
						className={classes.dropdown}
						value={jobPlacementOccupation}
						onChange={handleOccupationChange}
						SelectProps={{
							native: true,
							MenuProps: {
								className: classes.input,
							}
						}}
						InputProps={{
							inputProps: {
								className: classes.select,
							},
						}}
						label="Occupation"
						margin="dense"
						variant="outlined"
					>
						{(!jobPlacementOccupation || OCCUPATIONS.indexOf(jobPlacementOccupation) === -1) && <option />}
						{OCCUPATIONS.map((option: string) => (
							<option key={option} value={option}>
								{option || ''}
							</option>
						))}
					</TextField>
				</Grid>
				<Grid item={true} xs={12} sm={4}>
					<TextField
						name="jobPlacementIndustry"
						select={true}
						required={required}
						className={classes.dropdown}
						value={jobPlacementIndustry || ''}
						onChange={handleIndustryChange}
						SelectProps={{
							native: true,
							MenuProps: {
								className: classes.input,
							}
						}}
						InputProps={{
							inputProps: {
								className: classes.select,
							},
						}}
						label="Industry"
						margin="dense"
						variant="outlined"
					>
						{(!jobPlacementIndustry || OCCUPATIONS.indexOf(jobPlacementIndustry) === -1) && <option value="" />}
						{INDUSTRIES.map((option: string) => (
							<option key={option} value={option}>
								{option || ''}
							</option>
						))}
					</TextField>
				</Grid>
			</Grid>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
		input: {},
		select: {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
		},
    requiredField:{
      color:'red'
    }
	})

export default withStyles(styles)(TrainingHours)
